// GraphQL queries for Adobe Commerce as a Cloud Service (SaaS)
// Based on actual Adobe Commerce SaaS GraphQL schema

export const PRODUCT_DETAILS_QUERY = `
  query getProductBySku($sku: String!) {
    products(skus: [$sku]) {
      id
      name
      sku
      __typename
      description
      shortDescription
      inputOptions{
        id
        title
        type
        title
      }
      metaTitle
      metaDescription
      urlKey
      inStock
      ... on SimpleProductView {
        price {
          regular {
            amount {
              value
              currency
            }
          }
          final {
            amount {
              value
              currency
            }
          }
          tiers {
            tier {
              amount {
                currency
                value
              }
            }
            quantity {
              ... on ProductViewTierRangeCondition {
                gte
                lt
              }
            }
          }
        }
      }
      ... on ComplexProductView {
        priceRange {
          minimum {
            regular {
              amount {
                value
                currency
              }
            }
            final {
              amount {
                value
                currency
              }
            }
            tiers {
              tier {
                amount {
                  currency
                  value
                }
              }
              quantity {
                ... on ProductViewTierRangeCondition {
                  gte
                  lt
                }
              }
            }
          }
          maximum {
            regular {
              amount {
                value
                currency
              }
            }
            final {
              amount {
                value
                currency
              }
            }
            tiers {
              tier {
                amount {
                  currency
                  value
                }
              }
              quantity {
                ... on ProductViewTierRangeCondition {
                  gte
                  lt
                }
              }
            }
          }
        }
      }
      images {
        url
        label
        roles
      }
      videos {
        url
        description
      }
      attributes {
        label
        name
        roles
        value
      }
      links (linkTypes:["related"]) {
        position
        product {
          sku
          name
          
           attributes {
            label
            name
            roles
            value
          }

          images {
            url
            label
            roles
          }
        }
      }
    }
  }
`;

export const PRODUCTS_LIST_QUERY = `
  query getProducts($phrase: String) {
    productSearch(phrase: $phrase) {
      items {
        productView {
          id
          name
          sku
          description
          shortDescription
          urlKey
          images {
            url
            label
            roles
          }
          attributes {
            name
            value
            roles
          }
        }
      }
      page_info {
        page_size
        current_page
        total_pages
      }
      total_count
      facets {
        title
        buckets {
          title
          count
        }
      }
    }
  }
`;

export const PRODUCT_SEARCH_QUERY = `
  query productSearch($phrase: String!, $filter: [SearchClauseInput!]) {
    productSearch(phrase: $phrase, filter: $filter) {
      items {
        productView {
          id
          name
          sku
          description
          shortDescription
          urlKey
          images {
            url
            label
            roles
          }
          attributes {
            name
            value
            roles
          }
        }
      }
      page_info {
        page_size
        current_page
        total_pages
      }
      total_count
      facets {
        title
        buckets {
          title
          count
        }
      }
    }
  }
`;

// Query to fetch multiple products by their IDs (for Recently Viewed)
export const MULTIPLE_PRODUCTS_QUERY = `
  query getMultipleProductsById($ids: [String!]!) {
    products(ids: $ids) {
      id
      name
      sku
      description
      shortDescription
      urlKey
      images {
        url
        label
        roles
      }
      attributes(roles: ["visible_in_pdp", "visible_in_plp", "visible_in_search"]) {
        label
        name
        roles
        value
      }
    }
  }
`;

// Get complete list of product attributes with their codes and labels
export const ATTRIBUTES_LIST_QUERY = `
  query getAttributesList {
    attributesList(entityType: CATALOG_PRODUCT) {
      items {
        code
        label
        entity_type
      }
    }
  }
`;

// Query to get variants for configurable products
export const PRODUCT_VARIANTS_QUERY = `
  query getProductVariants($sku: String!, $optionIds: [String!], $pageSize: Int) {
    variants(sku: $sku, optionIds: $optionIds, pageSize: $pageSize) {
      variants {
        selections
        product {
          id
          name
          sku
          description
          inStock
          shortDescription
          images {
            url
            label
            roles
          }
          attributes(roles: []) {
            label
            name
            value
            roles
          }
          ... on SimpleProductView {
            price {
              regular {
                amount {
                  value
                  currency
                }
              }
              final {
                amount {
                  value
                  currency
                }
              }
            }
          }
        }
      }
      cursor
    }
  }
`;

export const CUSTOMER_ORDER_QUERY = `


  query Customer(
    $currentPage: Int
    $pageSize: Int
    $filter: CustomerOrdersFilterInput
  ) {
    customer {
        firstname
        lastname
        middlename
        email
        
      orders(
        currentPage: $currentPage
        pageSize: $pageSize
        filter: $filter
      ) {
        page_info {
          page_size
          total_pages
          current_page
        }
        date_of_first_order
        total_count
        items {
          token
          email
          
          custom_attributes{
					attribute_code
					value
				}
          
          shipping_method
          payment_methods {
            name
            type
          }
          shipping_address {
            firstname
            lastname
            city
            company
            country_code
            region
            region_id
            postcode
            street
            telephone
          }
          billing_address {
            firstname
            lastname
            city
            company
            country_code
            region
            region_id
            postcode
            street
            telephone
          }
          shipments {
            id
            number
            tracking {
              title
              number
              carrier
            }
          }
          number
          id
          order_date
          carrier
          status
          items {
            status
            product_name
            id
            quantity_ordered
            quantity_shipped
            quantity_invoiced
            product_sale_price {
            value
            currency
          }
          selected_options {
            label
            value
          }
            custom_attributes{
						attribute_code
						value
					}					
					selected_options{
						label
						value
					}

            product {
              sku
              url_key
              small_image {
                url
              }
                  custom_attributesV2 {
                  items {
                    code
                    ... on AttributeValue {
                      value
                    }
                    ... on AttributeSelectedOptions {
                      selected_options {
                        value
                        label
                      }
                    }
                  }
                }
            }
           entered_options{
						label
						value
					}
          }
          total {
            subtotal_excl_tax {
                value
                currency
            }
            subtotal_incl_tax {
                value
                currency
            }
            grand_total {
              value
              currency
            }
            total_tax {
              value
              currency
            }
            total_shipping {
              value
              currency
            }
            discounts {
              amount {
                value
                currency
              }
              label
            }
            taxes {
              amount {
                value
                currency
              }
              title
              rate
            }
          }
        }
      }
    }
  }
`;

export const GUEST_ORDER_QUERY = `
  query GuestOrder($input: GuestOrderInformationInput!) {
  guestOrder(input: $input) {
    id
    number
    token
    email
    status
    order_date
    order_status_change_date
    is_virtual
    available_actions
    carrier
    shipping_method
    customer_info {
    firstname 
    lastname 
    middlename
    }
    payment_methods {
      name
      type
    }
    shipping_address {
      firstname
      lastname
      city
      company
      country_code
      region
      region_id
      postcode
      street
      telephone
    }
    billing_address {
      firstname
      lastname
      city
      company
      country_code
      region
      region_id
      postcode
      street
      telephone
    }
    shipments {
      id
      number
      tracking {
        title
        number
        carrier
      }
    }
    items {
      id
      status
      product_name
      quantity_ordered
      quantity_shipped
      quantity_invoiced
      product_sku
      product_sale_price {
        value
        currency
      }
      selected_options {
        label
        value
      }
      
            product {
                  custom_attributesV2 {
                  items {
                    code
                    ... on AttributeValue {
                      value
                    }
                    ... on AttributeSelectedOptions {
                      selected_options {
                        value
                        label
                      }
                    }
                  }
                }
            }  
    }
    applied_coupons {
      code
    }
    total {
       subtotal_excl_tax {
          value
          currency
       }
      subtotal_incl_tax {
          value
          currency
      }
      grand_total {
        value
        currency
      }
      total_tax {
        value
        currency
      }
      total_shipping {
        value
        currency
      }
      discounts {
        label
        amount {
          value
          currency
        }
      }
    }
  }
}
`;
